import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { suggestFields } from '~data/actions/bookmarks';

import { Layout, Separator } from '~ui';
import Cover from './cover';
import Note from './note';
import Collection from './collection';
import Tags from './tags';
import Action from './action';
import Title from './title';
import Link from './link';
import Reminder from './reminder';
import Important from './important';
import Date from './date';

export default function BookmarkEditForm(props) {
  const dispatch = useDispatch();

  //load suggestions
  useEffect(() => {
    dispatch(suggestFields(props.item));
  }, [props.item._id, props.status]);

  const onSubmitForm = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();

      props.onSave().then(() => {
        if (props.autoWindowClose) window.close();
      });
    },
    [props.onSave, props.autoWindowClose],
  );

  return (
    <form
      className='ui-edit-form relative flex-1'
      data-status={props.status}
      onSubmit={onSubmitForm}
    >
      <Layout type='grid'>
        <Cover {...props} />
        <Title {...props} />
        <Note {...props} />

        <Collection {...props} />
        <Tags {...props} />
        <Link {...props} />

        <div />
        <div className='flex flex-row flex-wrap items-center gap-[var(--padding-small)]'>
          <Important {...props} />
          <Reminder {...props} />
        </div>

        <Date {...props} />

        <Separator variant='transparent' />

        <Action {...props} />
      </Layout>
    </form>
  );
}
